import { Injectable } from '@angular/core';
import { SessionApiProvider } from '@app/core/session/session-api-provider';
import { Observable, switchMap } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { SettingsService } from '@app/core/settings/settings.service';
import { SessionOidcApiService } from '@app/core/session/session-oidc-api.service';
import { SessionApiService } from '@app/core/session/session-api.service';

@Injectable()
export class SessionApiMigrationProviderService implements SessionApiProvider {
  constructor(private settingsService: SettingsService,
              private oidcProvider: SessionOidcApiService,
              private oldProvider: SessionApiService) { }

  public signOut(): Observable<unknown> {
    return this.getProvider()
      .pipe(
        switchMap(provider => provider.signOut()),
      );
  }

  public authenticateBasically(): Observable<boolean> {
    return this.getProvider()
      .pipe(
        switchMap(provider => provider.authenticateBasically()),
      );
  }

  private getProvider(): Observable<SessionApiProvider> {
    return this.settingsService.getSettingsOnce()
      .pipe(
        map(settings => settings.isHybridLoginFlow() && settings.new_auth_enabled),
        map(useNew => useNew ? this.oidcProvider : this.oldProvider),
        first(),
      );
  }
}
